<template>
  <div>
    <div class="Dashboard">
      <div class="Dashboard-Row Dashboard-CustomerData">
        <CustomerData class="Dashboard-DataCard" />
        <CustomerFeedback class="Dashboard-DataCard" />
      </div>
      <div class="Dashboard-Row Dashboard-OperatorData">
        <CampusCustomerData class="Dashboard-DataCard" />
        <EquipmentList class="Dashboard-DataCard" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EquipmentList from './EquipmentList/EquipmentList';
import CustomerFeedback from './CustomerFeedback/CustomerFeedback';
import CustomerData from './CustomerData/CustomerData';
import CampusCustomerData from './CampusCustomerData/CampusCustomerData';

export default {
  name: 'Dashboard',
  components: {
    CustomerData,
    CustomerFeedback,
    EquipmentList,
    CampusCustomerData,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.updateBackPage(from.name);
    });
  },
  created() {
    this.initData();
  },
  data() {
    return {
      timer: null,
    };
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    ...mapActions('Dashboard', [
      'fetchConsumeList',
      'fetchTitleList',
      'getWarnningCount',
    ]),
    ...mapActions(['updateBackPage']),
    initData() {
      this.fetchConsumeList();
      this.fetchTitleList();
      this.getWarnningCount();
      this.timer = setInterval(() => {
        this.getWarnningCount();
      }, 900000);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variables.scss';
.Dashboard {
  width: 100%;
  height: 100%;
  background-color: #eee;
  padding: 0 34px 38px;
  overflow-y: scroll;
  .Dashboard-Row {
    height: calc(50% + (38px / 2 - 8px));
    margin-top: 8px;
    overflow: hidden;
  }
  .Dashboard-title {
    font-size: 20px;
    color: #333;
    font-weight: 700;
  }
  .Dashboard-DataCard {
    background-color: #fff;
    border-radius: 8px;
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
  }
  .Dashboard-SearchBar {
    display: flex;
    padding: 10px 0 20px;
    .el-input,
    .el-input__inner,
    .filter-item {
      height: 34px;
      line-height: 34px;
    }
    .filter-item {
      margin: 0 0 0 34px;
    }
    .el-input,
    .filter-item-label {
      min-width: 40px;
    }
    .Dashboard-Radio {
      margin-left: 10px;
      display: flex;
      align-items: center;
      justify-self: flex-end;
      .Dashboard-Radio-item {
        font-size: 12px;
        margin: 0 10px 0 0;
        .el-radio__label {
          padding-left: 2px;
        }
      }
    }
  }
  .Dashboard-CustomerData {
    display: flex;
    .Dashboard-SearchBar {
      justify-content: space-between;
      border-bottom: 1px solid #f1f1f1;
      .filter-item {
        margin: 0 0 0 10px;
        .filter-item-input {
          width: auto;
        }
      }
    }
    .Dashboard-DataCard {
      &:first-child {
        flex: 4;
      }
      &:last-child {
        flex: 1;
      }
    }
  }

  .Dashboard-OperatorData {
    // flex: 1;
    display: flex;
    // padding-bottom: 12px;
    // height: 400px;
    .Dashboard-SearchBar {
      align-items: center;
      justify-content: space-between;
      padding: 0;
      height: 70px;
      border-bottom: 1px solid #f1f1f1;
      .filter-item {
        margin: 0 0 0 10px;
        .filter-item-input---normal {
          width: 113px;
        }
      }
    }
    .Dashboard-title {
      display: flex;
      align-items: center;
      .Dashboard-title-icon.service {
        width: 28px;
        height: 28px;
        margin-right: 13px;
      }
      .Dashboard-title-icon.equipment {
        width: 36px;
        height: 20px;
        margin-right: 12px;
      }
      .Dashboard-title-text {
        flex: 1;
      }
      .Dashboard-title-top {
        font-size: 20px;
        color: #4e83fb;
      }
    }
    .Dashboard-DataCard {
      &:first-child {
        flex: 3.5;
      }

      &:last-child {
        flex: 1.5;
      }
    }
  }
  .Dashboard-OperatorData,
  .Dashboard-CustomerData {
    .Dashboard-title {
      position: relative;
      padding: 20px 0 12px;
      margin: 0 20px;
    }
    .Dashboard-title::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 32px;
      height: 4px;
      background-color: #4e82fb;
    }
  }
}
@media screen and (max-width: $bigScreenWidth) {
  .Dashboard {
    .Dashboard-title {
      font-size: 14px;
    }
    .Dashboard-SearchBar {
      padding: 10px 0 10px;
    }
    .Dashboard-OperatorData {
      .Dashboard-SearchBar {
        height: 50px;
      }
      .Dashboard-title {
        margin: 10px 10px 0;
        padding-bottom: 10px;
      }
    }
  }
}
</style>
